import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from '@/modules/allies/allies/store/walletSlice/initialState.ts'
import { NestedFilterObject } from '@/core/hooks/useFiltersInBody'

const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<NestedFilterObject>) => {
      state.filters = action.payload
    },
    reset: () => initialState
  }
})

export const walletActions = walletSlice.actions
export const { reducer: walletReducer } = walletSlice
